module.exports = __webpack_public_path__ + "img/none_comm_png@2x.bf06163c.png";